<template>
    <div>
        <app-sub-title text="Usuario restringidos" />
        <b-button variant="primary" @click="startSave" class="btn-block-xs-only"
            ><i class="fa fa-plus"></i> Crear usuario restringido</b-button
        >
        <app-restricted-visitors-filters @filter="onFilter" />
        <app-restricted-visitors-list
            :data="data"
            @change-page="changePage"
            @update-restricted-visitor="startUpdate"
            @remove-restricted-visitor="startRemove"
            @upload-photo="startUploadPhoto"
            @sort="onSort"
        />

        <!-- inicio de pop up's -->
        <app-pop-up title="Confirmación" id="upload-photo-visitor">
            <div slot="body">
                <b-card
                    title="Foto del usuario restringido"
                    tag="article"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-form-file
                            v-model="file"
                            :state="Boolean(file)"
                            placeholder="Seleccione imagen del usuario restringido"
                            accept=".jpg, .jpeg, .png"
                            ref="fileinput"
                        ></b-form-file>
                        <div v-if="file" class="mt-3">
                            Archivo seleccionado: {{ file && file.name }}
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="uploadPhoto(selectedRestrictedVisitor)"
                >
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i> Cargar
                    foto al sistema
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="restricted-visitor-remove">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea eliminar este usuario restringido?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteRestrictedVisitor(selectedRestrictedVisitor)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Formulario de sede"
            id="restricted-visitor-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <app-restricted-visitor-form
                    :my-restricted-visitor="selectedRestrictedVisitor"
                    :onSave="onSave"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('restricted-visitor-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop up's -->
    </div>
</template>
<script>
import restrictedVisitorsRepository from "../../../../repositories/restrictedVisitors.repository.js";
import RestrictedVisitorForm from "./RestrictedVisitorForm/RestrictedVisitorForm.vue";
import RestrictedVisitorsList from "./RestrictedVisitorsList/RestrictedVisitorsList.vue";
import RestrictedVisitorsFilters from "./RestrictedVisitorsFilters/RestrictedVisitorsFilters.vue";
export default {
    components: {
        appRestrictedVisitorForm: RestrictedVisitorForm,
        appRestrictedVisitorsList: RestrictedVisitorsList,
        appRestrictedVisitorsFilters: RestrictedVisitorsFilters
    },
    data() {
        return {
            data: {},
            page: 1,
            selectedRestrictedVisitor: "",
            filters: {},
            sort: {
                sortBy: "name",
                sortDir: "asc"
            },
            file: ""
        };
    },
    methods: {
        loadRestrictedVisitors() {
            const rvr = { ...restrictedVisitorsRepository };
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir
            };
            rvr.loadRestrictedVisitors(
                !!this.client ? this.client.id : filters.client,
                filters,
                this.page
            )
                .then(data => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error(
                        "Error al cargar los usuarios restringidos del cliente"
                    );
                });
        },
        changePage(page) {
            this.page = page;
            this.loadRestrictedVisitors();
        },
        onFilter(filters) {
            this.filters = filters;
            this.loadRestrictedVisitors();
        },
        startSave() {
            this.selectedRestrictedVisitor = "";
            this.$bus.$emit("restricted-visitor-form.open");
        },
        onSave() {
            this.$bus.$emit("restricted-visitor-form.close");
            this.loadRestrictedVisitors();
        },
        cleanForm() {
            this.$bus.$emit("restricted-visitor-form.clean");
        },
        startUpdate(restrictedVisitor) {
            this.selectedRestrictedVisitor = Object.assign(
                {},
                restrictedVisitor
            );
            this.$bus.$emit("restricted-visitor-form.open");
        },
        startRemove(restrictedVisitor) {
            this.selectedRestrictedVisitor = restrictedVisitor;
            this.$bus.$emit("restricted-visitor-remove.open");
        },
        startUploadPhoto(restrictedVisitor) {
            this.selectedRestrictedVisitor = restrictedVisitor;
            this.$bus.$emit("upload-photo-visitor.open");
        },
        deleteRestrictedVisitor(restrictedVisitor) {
            const rvr = { ...restrictedVisitorsRepository };
            rvr.deleteRestrictedVisitor(restrictedVisitor.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadRestrictedVisitors();
                        this.$bus.$emit("restricted-visitor-remove.close");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No se pudo borrar el usuario restringido");
                });
        },
        uploadPhoto(restrictedVisitor) {
            if (!this.file) {
                toastr.error(
                    "Debe seleccionar la foto del usuario restringido"
                );
                return false;
            }

            const formData = new FormData();

            formData.append("restrictedVisitorId", restrictedVisitor.id);
            formData.append("file", this.file);

            const rvr = { ...restrictedVisitorsRepository };
            rvr.uploadPhotoRestrictedVisitor(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadRestrictedVisitors();
                        this.$refs.fileinput.reset();
                        this.$bus.$emit("upload-photo-visitor.close");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Error al cargar foto del usuario restringido"
                    );
                });
        },
        initialize() {
            this.loadRestrictedVisitors();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadRestrictedVisitors();
        }
    },
    created() {
        this.initialize();
    }
};
</script>
